import React from 'react';
import styles from '../ChatWidget.module.scss';
import nekstAiIcon from './nekstAiIcon.png';

export default function TypingIndicator() {
  return (
    <div className={`${styles.messageRow} ${styles.messageRowAssistant}`}>
      <div className={styles.bubbleAvatar}>
        <img src={nekstAiIcon} alt="Nekst AI" width={28} height={28} />
      </div>
      <div className={styles.typingIndicator} data-testid="chat-typing-indicator">
        <span className={styles.typingDot} />
        <span className={styles.typingDot} />
        <span className={styles.typingDot} />
      </div>
    </div>
  );
}
